var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChuvaEraiosP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7761 16.5175C39.7547 16.5175 39.7332 16.5238 39.7118 16.5243C40.1238 15.5703 40.3538 14.5194 40.3538 13.4142C40.3538 9.07935 36.8396 5.5656 32.5068 5.5656C30.9742 5.5656 29.5486 6.01121 28.3399 6.77016C26.7057 2.79854 22.8036 0 18.2409 0C12.2111 0 7.32162 4.88931 7.32162 10.9202C7.32162 11.3763 7.35857 11.8226 7.4128 12.2638C7.3824 12.2634 7.35267 12.2592 7.32162 12.2592C3.27806 12.2592 0 15.5373 0 19.5808C0 23.6244 3.27806 26.9027 7.32162 26.9027H39.7761C42.6431 26.9027 44.97 24.5779 44.97 21.7101C44.97 18.8422 42.6431 16.5175 39.7761 16.5175Z",
    fill: "#BED7F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73819 39.6965C8.85592 41.5314 6.65322 42.3039 4.81828 41.4216C2.98356 40.5396 2.21083 38.3371 3.09288 36.5019C3.97493 34.667 9.67917 31.3096 9.67917 31.3096C9.67917 31.3096 10.62 37.8611 9.73819 39.6962V39.6965Z",
    fill: "#BED7F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8648 39.6965C40.9823 41.5314 38.7785 42.3039 36.9438 41.4216C35.1091 40.5396 34.3362 38.3371 35.2189 36.5019C36.1016 34.667 41.8062 31.3096 41.8062 31.3096C41.8062 31.3096 42.7451 37.8611 41.865 39.6962L41.8648 39.6965Z",
    fill: "#BED7F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5755 30.0405L16.2345 40.2129H20.8404L17.8536 50.5371L28.7358 35.9617H23.1166L25.2428 30.0405H19.5755Z",
    fill: "#FCDB7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChuvaEraiosP);
export default __webpack_public_path__ + "static/media/chuvaEraiosP.d5e267df6d6b9a36eeaad69ee7d87abd.svg";
export { ForwardRef as ReactComponent };